import React, { ReactNode } from 'react';
import { styled } from '@linaria/react';
import { SizesType } from 'types/Sizes';
import { cssTheme } from '../../../../themes';
import { Divider } from '../../Divider';
type BottomBarSize = Extract<SizesType, 'md' | 'lg'>;
export interface BottomBarProps {
  /** Content of the BottomBar */
  children: ReactNode;
  /** Determine if a divider is rendered in the top of the BottomBar */
  hasDivider?: boolean;
  /** Pass through className to allow styles overrides */
  className?: string;
  /** Whether the BottomBar should be sticky or not */
  sticky?: boolean;
  /** The size of the BottomBar (spacings) */
  size?: BottomBarSize;
}
const _exp2 = /*#__PURE__*/() => ({
  size
}) => size === 'lg' ? `${cssTheme.layout.spacing.s500} ${cssTheme.layout.spacing.s500 + cssTheme.layout.spacing.s200}` : `${cssTheme.layout.spacing.s400} ${cssTheme.layout.spacing.s500}`;
const _exp4 = /*#__PURE__*/() => ({
  sticky
}) => sticky ? `solid 1px ${cssTheme.colors.border.neutral.c100}` : 'none';
export const BottomBarWrapper = /*#__PURE__*/styled('div')({
  name: "BottomBarWrapper",
  class: "be8ntgh",
  propsAsIs: false,
  vars: {
    "be8ntgh-0": [_exp2()],
    "be8ntgh-1": [_exp4()]
  }
});
export const BottomBar = ({
  hasDivider = false,
  children,
  className,
  size = 'md',
  sticky = false
}: BottomBarProps) => {
  return <>
      {hasDivider && <Divider />}
      <BottomBarWrapper className={className} sticky={sticky} size={size}>
        {children}
      </BottomBarWrapper>
    </>;
};

require("./index.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");